const siblingcount = () => {
  const dataArray = [];
  for (let i = 0; i <= 20; i++) {
    dataArray.push({ value: i, label: i });
  }
  return dataArray;
};

export default siblingcount;
